import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 10;
      if (isScrolled !== scrolled) {
        setScrolled(isScrolled);
      }
    };

    document.addEventListener('scroll', handleScroll);
    return () => {
      document.removeEventListener('scroll', handleScroll);
    };
  }, [scrolled]);

  return (
    <header className={`header ${scrolled ? 'scrolled' : ''}`}>
      <div className="container" style={{ position: 'relative' }}>
        <div className="logo-wrapper">
          <Link to="/" className="logo-link" aria-label="Nouria Home">
            {/* Botanical leaf SVG mark */}
            <svg
              className="logo-icon-svg"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 48 48"
              width="32"
              height="32"
              aria-hidden="true"
            >
              <path
                d="M24 4C13 4 5 14 5 26c0 10 6.5 17 13 19 0-8 3-14 6-18-1 6-1 12 1 18
                   6-2 13-9 13-19C38 14 35 4 24 4z"
              />
              <line
                x1="24" y1="45" x2="24" y2="22"
                stroke="white"
                strokeWidth="1.5"
                strokeLinecap="round"
                style={{ mixBlendMode: 'overlay' }}
              />
            </svg>
            <span className="logo-text">Nouria</span>
          </Link>
        </div>
        <button
          className="mobile-menu-btn"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="Toggle navigation menu"
          aria-expanded={mobileMenuOpen}
        >
          ☰
        </button>
        <nav className={mobileMenuOpen ? 'mobile-nav-open' : ''} aria-label="Main Navigation">
          <Link to="/" onClick={() => setMobileMenuOpen(false)}>Home</Link>
          <a href={isHome ? '#action' : '/#action'} onClick={() => setMobileMenuOpen(false)}>In Action</a>
          <a href={isHome ? '#science' : '/#science'} onClick={() => setMobileMenuOpen(false)}>Science</a>
          <Link
            to="/professionals"
            onClick={() => {
              setMobileMenuOpen(false);
              window.scrollTo({ top: 0, behavior: 'smooth' });
            }}
          >
            For Professionals
          </Link>
          <Link to="/blogs" onClick={() => setMobileMenuOpen(false)}>Blogs</Link>
          <Link to="/tools" onClick={() => setMobileMenuOpen(false)}>Free Tools</Link>
          <a href={isHome ? '#faq' : '/#faq'} onClick={() => setMobileMenuOpen(false)}>FAQs</a>
          <Link to="/help" onClick={() => setMobileMenuOpen(false)}>Help</Link>
          <a
            href="https://play.google.com/store/apps/details?id=com.masalachailabs.nouria"
            target="_blank"
            rel="noopener noreferrer"
            className="header-play-store-link"
            onClick={() => setMobileMenuOpen(false)}
            aria-label="Get Nouria on Android Google Play Store"
          >
            <img
              src="/google-play-badge-en.webp"
              alt="Get it on Google Play"
              className="header-play-store-img"
            />
          </a>
        </nav>
      </div>
    </header>
  );
}

export default Header;
